import { DataGridColSettings } from '@/components/DataGrid/utils';
import { randomDateWithin } from '@/pages/Tools/BuildingInspection/dummy_data/dummy_helper';
import { IViolation } from '@/pages/Tools/BuildingInspection/Models';

export const allViolations: IViolation[] = [
  {
    _id: 'v1',
    inspection_id: 'ins-001-1',
    issue: 'Broken emergency light fixture',
    location: 'Lobby ceiling',
    codeReference: 'REF0001',
    photoUrl: '/photos/emergency_light.jpg',
    isCorrected: true,
    issueDate: randomDateWithin(190),
  },
  {
    _id: 'v2',
    inspection_id: 'ins-001-1',
    issue: 'Blocked fire exit with boxes',
    location: 'Rear hallway',
    codeReference: 'REF0002',
    photoUrl: '/photos/fire_exit.jpg',
    isCorrected: false,
    issueDate: randomDateWithin(190),
  },
  {
    _id: 'v3',
    inspection_id: 'insp_103',
    issue: 'Improper wiring near water line',
    location: 'Maintenance room',
    codeReference: 'REF0003',
    photoUrl: '/photos/wiring_violation.jpg',
    issueDate: randomDateWithin(190),
  },
];

export const violationsDataGridCols: DataGridColSettings[] = [
  {
    field: 'issue',
    headerName: 'Issue',
    visible: true,
  },
  {
    field: 'location',
    headerName: 'Location',
    visible: true,
  },
  {
    field: 'codeReference',
    headerName: 'Code Reference',
    visible: true,
  },
  {
    field: 'photoUrl',
    headerName: 'Photo',
    visible: true,
  },
  {
    field: 'actions',
    headerName: 'Actions',
    visible: true,
  },
];

export const violationsDataGridReducedCols: DataGridColSettings[] = [
  {
    field: 'issue',
    headerName: 'Issue',
    visible: true,
  },
  {
    field: 'location',
    headerName: 'Location',
    visible: true,
  },
  {
    field: 'codeReference',
    headerName: 'Code Reference',
    visible: true,
  },
  {
    field: 'photoUrl',
    headerName: 'Photo',
    visible: true,
  },
];

export const violationsFormFields = [
  {
    name: 'issue',
    label: 'Issue',
    type: 'textarea',
    multiline: true,
    placehoder: '/',
    rows: 3,
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'location',
    label: 'Location',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'codeReference',
    label: 'Code reference',
    type: 'textarea',
    multiline: true,
    rows: 3,
    grid: {
      sm: 12,
      xs: 12,
    },
  },
  {
    name: 'Upload photo',
    type: 'file',
    label: 'Upload photo',
    grid: {
      sm: 12,
      xs: 12,
    },
  },
];
